import { action } from 'typesafe-actions';

import { BookletsTypes, IBooklet } from './types';

export const loadRequest = () => action(BookletsTypes.LOAD_REQUEST);
export const loadSuccess = (data: IBooklet[]) => action(BookletsTypes.LOAD_SUCCESS, data);
export const loadFailure = () => action(BookletsTypes.LOAD_FAILURE);
